module.exports = __webpack_public_path__ + "0af5d249/img/settings-icon.121d9519.svg";